import { Offcanvas } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { closeGridDrawer } from '@/app/common/reducers/gridDrawerSlice';
import AgGridWrapper from '../../app/common/components/ag-grid/AgGridWrapper';
import { memo, useState } from 'react';
import type { ColDef } from 'ag-grid-community';

interface GridDrawerItem {
  title: string;
  field?: string;
  columns: ColDef[];
  data: unknown[];
}

interface DrawerProps {
  drawer: GridDrawerItem;
}

const Drawer = ({ drawer }: DrawerProps) => {
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <Offcanvas
      show={drawerOpen}
      onHide={() => {
        setDrawerOpen(false);
        setTimeout(() => {
          dispatch(closeGridDrawer());
        }, 500);
      }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{drawer.title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div>
          <AgGridWrapper
            height="900px"
            columns={drawer.columns}
            data={drawer.data}
          />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

const GridDrawer = () => {
  const gridDrawer = useSelector(
    (state: { gridDrawer: GridDrawerItem[] }) => state.gridDrawer,
  );

  return (
    <>
      {gridDrawer.map((drawer, index) => (
        <div key={index}>
          <Drawer drawer={drawer} />
          <style>
            {`
          .offcanvas{
              width:1300px !important;
               max-width:100% !important;
             }
           `}
          </style>
        </div>
      ))}
    </>
  );
};

export default memo(GridDrawer);
